module.exports = __webpack_public_path__ + "static/img/ne.052dc664.svg";